import React, { Button, Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../../widgets/tables/Table";
import WaitDialog from "../../../widgets/WaitDialog";

import SendMailWidget from "../../../widgets/SendMailWidget";
import SendNotificationWidget from "../../../widgets/SendNotificationWidget";
import GetStudenti from "../../../services/getStudentiForBilling";
import getCorsi from "../../../services/getCorsi";
import addNotification from "../../../services/addNotification";
import sendMail from "../../../services/sendMail";
import saveFile from "../../../services/saveFile";
import getSetting from "../../../services/getSetting";
import Utils from "../../../utils/utils";
import SelectInput from "../../../widgets/SelectInput";
import FixButton from "../../../widgets/Button";
import getStudentiForBilling from "../../../services/getStudentiForBilling";
import generateExcel from "../../../services/generateExcel";
import Constants from "../../../utils/consts";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import WaitDialogFileDownload from "../../../widgets/WaitDialogFileDownload";
import getRataStatus from "../../../services/getRataStatus";
import getAnniAccademici from "../../../services/getAnniAccademici";
import moment from "moment";

export default class Studenti extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [],
    };

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.pageTitle = "Studenti";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });

    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      anni_accademici: [{ value: "", label: "" }],
      anno_accademico: { value: "", label: "" },
      waitDialogFileVisible: false,
      fileReady: false,
    };
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.studenti = await GetStudenti(username, token);
    this.anni = await getAnniAccademici(username, token);

    var options = [];
    options.push({ value: "", label: "" });

    for (var anno of this.anni) {
      if (anno.anno != "") options.push({ value: anno.anno, label: anno.anno });
    }

    this.setState({ anni_accademici: options });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    var headCells = [
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "mail", numeric: true, disablePadding: false, label: "Mail" },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["nome", "cognome", "mail"];

    const cookies = new Cookies();

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />

          <div style={{ display: "inline-flex", marginBottom: "10px" }}>
            <SelectInput
              key={Math.random()}
              ref={this.selectRef}
              value={this.state.anno_accademico}
              name="Anno accademico"
              hidable={false}
              options={this.state.anni_accademici}
              isMulti={false}
              onChange={(option) => this.setState({ anno_accademico: option })}
            />

            <div style={{ height: "30px", top: "24px", position: "relative" }}>
              <FixButton
                title={"Genera Excel"}
                callback={async () => {
                  const annoAccademico = this.state.anno_accademico.value;

                  if (annoAccademico == "") {
                    alert("Seleziona prima un anno accademico");
                    return;
                  }

                  this.setState({
                    waitDialogFileVisible: true,
                    fileReady: false,
                  });

                  const cookies = new Cookies();
                  const username = cookies.get("username", { path: "/" });
                  const token = cookies.get("token", { path: "/" });

                  this.corsi = await getCorsi(username, token);
                  this.studenti = await getStudentiForBilling(username, token);

                  this.corsi = this.corsi.filter(
                    (c) => c.anno_accademico == annoAccademico
                  );

                  var jsonData = [];
                  jsonData.push([
                    "CORSO",
                    "GIORNO",
                    "Note",
                    "",
                    "ISCRITTI",
                    " Prezzo applicato ",
                    " Listino ",
                    " Pagato ",
                    " Rimanenza ",
                    "N. Rate",
                    " Rata1 ",
                    "DATA",
                    " Rata2 ",
                    "DATA",
                    " Rata3 ",
                    "DATA",
                    " Rata4 ",
                    "DATA",
                    " Rata5 ",
                    "DATA",
                    " Rata6 ",
                    "DATA",
                    " Rata7 ",
                    "DATA",
                    " Rata8 ",
                    "DATA",
                    " Rata9 ",
                    "DATA",
                    " Rata10 ",
                    "DATA",
                  ]);

                  for (var corso of this.corsi) {
                    var studentiCorso = this.studenti.filter((s) =>
                      s.corsi
                        .split(";")
                        .filter(Boolean)
                        .includes(corso.id.toString())
                    );
                    for (var studente of studentiCorso) {
                      var note = "";
                      if (studente.disabled == 1) note = "Ritirato";
                      var pianoStudente = await getPianoPagamentiCorsoStudenti(
                        username,
                        token,
                        corso.id,
                        studente.id
                      );
                      if (pianoStudente == null || pianoStudente == undefined) {
                        var pianoStudente = await getPianoPagamentiCorso(
                          username,
                          token,
                          corso.id
                        );
                      }

                      var prezzoApplicato = "0";
                      if (pianoStudente != null && pianoStudente != undefined) {
                        prezzoApplicato = pianoStudente.costo;
                      }

                      var rate = await getRataStatus(
                        username,
                        token,
                        corso.id,
                        studente.id
                      );
                      var totalePagato = 0;
                      var rimanenza = 0;

                      var rata1 = "",
                        rata2 = "",
                        rata3 = "",
                        rata4 = "",
                        rata5 = "",
                        rata6 = "",
                        rata7 = "",
                        rata8 = "",
                        rata9 = "",
                        rata10 = "";
                      var data1 = "",
                        data2 = "",
                        data3 = "",
                        data4 = "",
                        data5 = "",
                        data6 = "",
                        data7 = "",
                        data8 = "",
                        data9 = "",
                        data10 = "";

                      var index = 1;
                      for (var rata of rate) {
                        rate = rate.sort((l1, l2) => {
                          var data1 = moment(l1.data, "DD-MM-yyyy");
                          var data2 = moment(l2.data, "DD-MM-yyyy");
                          return data1 < data2 ? -1 : 1;
                        });

                        if (rata.status == "PAGATA") {
                          if (index == 1) {
                            rata1 = rata.importo;
                            data1 = rata.data;
                          }
                          if (index == 2) {
                            rata2 = rata.importo;
                            data2 = rata.data;
                          }
                          if (index == 3) {
                            rata3 = rata.importo;
                            data3 = rata.data;
                          }
                          if (index == 4) {
                            rata4 = rata.importo;
                            data4 = rata.data;
                          }
                          if (index == 5) {
                            rata5 = rata.importo;
                            data5 = rata.data;
                          }
                          if (index == 6) {
                            rata6 = rata.importo;
                            data6 = rata.data;
                          }
                          if (index == 7) {
                            rata7 = rata.importo;
                            data7 = rata.data;
                          }
                          if (index == 8) {
                            rata8 = rata.importo;
                            data8 = rata.data;
                          }
                          if (index == 9) {
                            rata9 = rata.importo;
                            data9 = rata.data;
                          }
                          if (index == 10) {
                            rata10 = rata.importo;
                            data10 = rata.data;
                          }

                          totalePagato += parseFloat(rata.importo);
                        }

                        index++;
                      }

                      rimanenza = parseFloat(prezzoApplicato) - totalePagato;

                      jsonData.push([
                        corso.name,
                        "",
                        note,
                        "",
                        studente.cognome + " " + studente.nome,
                        prezzoApplicato,
                        "",
                        totalePagato.toString(),
                        rimanenza.toString(),
                        pianoStudente ? pianoStudente.rate.length : 0,
                        rata1,
                        data1,
                        rata2,
                        data2,
                        rata3,
                        data3,
                        rata4,
                        data4,
                        rata5,
                        data5,
                        rata6,
                        data6,
                        rata7,
                        data7,
                        rata8,
                        data8,
                        rata9,
                        data9,
                        rata10,
                        data10,
                      ]);
                    }
                  }

                  var jsonTabs = [];
                  jsonTabs.push({
                    name: "Fatturazione",
                    data: jsonData,
                  });

                  var json = {
                    tabs: jsonTabs,
                  };

                  await generateExcel(
                    username,
                    token,
                    JSON.stringify(json),
                    "rate_studenti"
                  );
                  this.setState({ fileReady: true });
                }}
              />
            </div>
          </div>

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            calendar={false}
            pdf={false}
            excel={false}
            mail={false}
            phone={false}
            rows={this.studenti}
            onEventClick={(row) => {
              cookies.set("currentStudent", row, { path: "/" });
              window.location.href = "/#/billing/studenteDetails";
            }}
          />

          {this.elementPdf ? this.elementPdf : null}
          <SendMailWidget
            ref={this.sendMailRef}
            show={this.state.sendMailVisible}
            onClose={() => this.setState({ sendMailVisible: false })}
            onSend={async (subject, body, file) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              this.mail = await getSetting(
                username,
                token,
                "sendingMailAddress"
              );
              this.mailPassword = await getSetting(
                username,
                token,
                "sendingMailPassword"
              );

              //            this.state.sendMailUserId
              var studente = this.studenti.find(
                (s) => s.id == this.state.sendMailUserId
              );
              studente.mail = studente.mail.trim();
              studente.mail2 = studente.mail2.trim();

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              if (
                studente.mail != "" &&
                Utils.validateEmail(studente.mail) == false
              ) {
                alert("L'indirizzo " + studente.mail + " non è valido");
                return;
              }
              if (
                studente.mail2 != "" &&
                Utils.validateEmail(studente.mail2) == false
              ) {
                alert("L'indirizzo " + studente.mail2 + " non è valido");
                return;
              }

              if (studente.mail != "")
                await sendMail(
                  username,
                  token,
                  this.mail,
                  "Accademia Nazionale del Cinema",
                  this.mailPassword,
                  studente.mail,
                  studente.nome + " " + studente.cognome,
                  file ? this.filePath.name : "",
                  subject,
                  body
                );
              if (studente.mail2 != "")
                await sendMail(
                  username,
                  token,
                  this.mail,
                  "Accademia Nazionale del Cinema",
                  this.mailPassword,
                  studente.mail2,
                  studente.nome + " " + studente.cognome,
                  file ? this.filePath.name : "",
                  subject,
                  body
                );

              this.setState({ waitDialogVisible: false });
              this.setState({ sendMailVisible: false });
            }}
          />

          <SendNotificationWidget
            ref={this.sendNotificationRef}
            show={this.state.sendNotificationVisible}
            onClose={() => this.setState({ sendNotificationVisible: false })}
            onSend={async (subject, body, bodyFull) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              await addNotification(
                username,
                token,
                "STUDENTE",
                this.state.notificationUser,
                subject,
                body,
                bodyFull,
                0
              );

              this.setState({ waitDialogVisible: false });
              this.setState({ sendNotificationVisible: false });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
          <WaitDialogFileDownload
            onClose={() => this.setState({ waitDialogFileVisible: false })}
            show={this.state.waitDialogFileVisible}
            ready={this.state.fileReady}
            file={"https://" + Constants.mainUrl + "pdf/rate_studenti.xlsx"}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </>
    );
  }
}
